module.exports = __webpack_public_path__ + "img/GL.862c73b1.png";